import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const enabled = import.meta.env.VITE_SENTRY_ENABLED === 'true';

  if (!enabled || !dsn) return;

  // Parse sample rate safely — an invalid env var value becomes NaN, so fall back to 0.1.
  const rawRate = parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE);
  const tracesSampleRate = isNaN(rawRate) ? 0.1 : rawRate;

  try {
    Sentry.init({
      dsn,
      environment: import.meta.env.VITE_ENV || import.meta.env.MODE,
      tracesSampleRate,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  } catch (err) {
    // Sentry init failure must not crash the app.
    console.error('Sentry initialization failed:', err);
  }
}

export { Sentry };
